import React from "react";
import { FaHatCowboy } from "react-icons/fa6";
import { DiAndroid } from "react-icons/di";
import { Link } from "react-router-dom";

const Max_404_page = () => {
  return (
    <>
      <div className="container-fluid mt-2">
        <div
          className="row p-5"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="col-sm-12 m-4">
            <div className="not-found">
              <FaHatCowboy className="cap-font" />
              <h1>
                <DiAndroid className="android-size" />
              </h1>
              <h2 className="notFound-font">404 - Not Found</h2>
              <p>Sorry, the page you are looking for might not exist.</p>
              <Link to="/Dashboard" className="backToDash">
                Back to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Max_404_page;
